import React from "react";
import AdditionalPrizeFund from "../PrizeFund/AdditionalPrizeFund/AdditionalPrizeFund";
import AssignAdditionalPrizeFund from "../PrizeFund/PrizeFundDistribution/AssignAdditionalPrizeFund";

const FinancialTab = () => {
  return (
    <div className="space-y-6">
      <AdditionalPrizeFund />
      <AssignAdditionalPrizeFund />
    </div>
  );
};

export default FinancialTab;
